import { render, staticRenderFns } from "./ptgk.vue?vue&type=template&id=7d2d3c2a"
import script from "./ptgk.vue?vue&type=script&lang=js"
export * from "./ptgk.vue?vue&type=script&lang=js"
import style0 from "./ptgk.vue?vue&type=style&index=0&id=7d2d3c2a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports